module.exports = __webpack_public_path__ + "img/meisyo_roulette_anime.00dd74f4.gif";